/* eslint ember/no-classic-classes:"off" */
import JSONSerializer from '@ember-data/serializer/json';
import { underscore } from '@ember/string';
export default JSONSerializer.extend({
  // allows us to set `{ readOnly: true }` in an attribute
  // to not have it sent to the server.
  serializeAttribute(snapshot, json, key, attribute) {
    // do not serialize the attribute!
    if (attribute.options && attribute.options.readOnly) {
      return;
    }
    this._super(snapshot, json, key, attribute);
  },
  keyForAttribute(attr) {
    return underscore(attr);
  },
  keyForRelationship(attr) {
    return underscore(attr);
  }
});